// src/pages/Dashboard/index.tsx
import React, { useState } from 'react';
import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import tokenStyles from '@/pages/Token/token.module.css';
import { useSafeEffect } from '../../hooks/useSafeEffect';
import { AppDispatch } from '../../store';
import { auth } from '../../store/auth/thunks';

const Token = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const handleCallback = async () => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    try {
      const resultAction = await dispatch(
        auth.token({
          code: code,
          state: state,
          ...(import.meta.env.MODE === 'development' && { local: true }),
        })
      );
      if (auth.token.fulfilled.match(resultAction)) {
        navigate('/home');
      } else if (auth.token.rejected.match(resultAction)) {
        console.error('Login failed:', resultAction.error);
        navigate('/');
      }
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'An unexpected error occurred';
      console.error('Login error:', errorMessage);
    }
  };

  useSafeEffect(() => {
    handleCallback();
  }, []);

  return (
    <Box className={tokenStyles.container}>
      <CircularProgress />
    </Box>
  );
};

export default Token;
